import {Injectable} from '@angular/core';

@Injectable()
export class BillingService {
  paidUser: any = '';

  constructor() {
    this.paidUser = 'self';
  }
}



// WEBPACK FOOTER //
// D:/CODE_REPOSITORIES/HIMS/HIMS_FRONTEND/src/app/billing/billing.service.ts